
<script setup>
import PopinAnchor from "@/components/molecules/popin-anchor";

const emit = defineEmits(["addToListeDeCourse"]);
</script>
<template>
  <div>
    <PopinAnchor
      icon-name="mes-listes"
      icon-size="md"
      icon-color="primary"
      icon-color-hover="white"
      popin-size="fit"
      position="top-right"
      infobulle
      open-on-hover
      variant="primary"
      radius="full"
      outline
      v-bind="removeClassAndStyleFromAttrs($attrs)"
      aria-label="Ajouter à une liste"
      @click="emit('addToListeDeCourse')"
    >
      <p class="u-font-14 u-color-text">
        Ajouter cet article <br />à une liste
      </p>
    </PopinAnchor>
  </div>
</template>
